import SimpleFormItem from "./SimpleFormItem";
import {ScreenConfig, ScreenType} from "../../config/ScreenConfig";
import {SeatConfig} from "../../config/SeatConfig";
import {AudioConfig} from "../../config/AudioConfig";
import {AisleMode, FloorColors, SpeakerType, useRoomConfig} from "../../model/RoomConfigContext";
import {useSeatConfig} from "../../model/SeatConfigContext";
import {useScreenConfig} from "../../model/ScreenConfigContext";
import {useAudioConfig} from "../../model/AudioConfigContext";

export default function Menu() {
    const {
        width,
        setWidth,
        height,
        setHeight,
        depth,
        setDepth,
        roofHeight,
        setRoofHeight,
        freeDepth,
        aisleWidth,
        setAisleWidth,
        aisleMode,
        setAisleMode,
        floorColor,
        setFloorColor,
        floorLedsOn,
        setFloorLedsOn,
        transparentWalls,
        setTransparentWalls,
    } = useRoomConfig();
    const {
        numRows,
        setNumRows,
        seatType,
        setSeatType,
        numSeats,
        setNumSeats,
        preferredRow,
        setPreferredRow,
        distance,
        setDistance,
        id: seatID,
        setConfigID: setSeatID,
        setModelID,
        models,
        maxAisleWidth,
    } = useSeatConfig();
    const {
        aspectRatio,
        setAspectRatio,
        screenSize,
        setScreenSize,
        id: screenID,
        setConfigID: setScreenID,
        aspectRatios,
        screenRange,
        projectorType,
        setProjectorType,
        acousticTransparent,
        setAcousticTransparent
    } = useScreenConfig();

    const {
        id: audioConfigID,
        type: speakerType,
        setConfigID: setAudioConfigID,
        surroundType,
        setSurroundType,
        rearInCeiling,
        setRearInCeiling,
        numCeilingSpeakers,
        builtInWall
    } = useAudioConfig();

    const widthOptions = [];
    const heightOptions = [];
    const depthOptions = [];
    const roofHeightOptions = [];
    let obj = {}
    let i;

    for (i = 250; i <= 750; i++) {
        obj = {};

        obj['value'] = i;
        obj['label'] = i;
        widthOptions.push(obj);
        depthOptions.push(obj);
    }

    for (i = 751; i <= 750; i++) {
        obj = {};

        obj['value'] = i;
        obj['label'] = i;
        depthOptions.push(obj);
    }

    for (i = 80; i <= 400; i++) {
        obj = {};

        obj['value'] = i;
        obj['label'] = i;
        heightOptions.push(obj);
    }

    for (i = 0; i <= 500; i++) {
        obj = {};

        obj['value'] = i;
        obj['label'] = i;
        roofHeightOptions.push(obj);
    }

    function scrollParentToChild(parent, child) {

        // Where is the parent on page
        var parentRect = parent.getBoundingClientRect();
        // What can you see?
        var parentViewableArea = {
            height: parent.clientHeight,
            width: parent.clientWidth
        };

        // Where is the child
        var childRect = child.getBoundingClientRect();
        // Is the child viewable?
        var isViewable = (childRect.top >= parentRect.top) && (childRect.bottom <= parentRect.top + parentViewableArea.height);

        // if you can't see the child try to scroll parent
        if (!isViewable) {
            // Should we scroll using top or bottom? Find the smaller ABS adjustment
            const scrollTop = childRect.top - parentRect.top;
            const scrollBot = childRect.bottom - parentRect.bottom;
            if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
                // we're near the top of the list
                parent.scrollTop += scrollTop;
            } else {
                // we're near the bottom of the list
                parent.scrollTop += scrollBot;
            }
        }
    }

    function checkNumberField(e) {
        if (parseInt(e.target.value) > parseInt(e.target.getAttribute('max'))) {
            e.target.value = e.target.getAttribute('max');
        }
        if (e.target.value.length === e.target.getAttribute('min').length && parseInt(e.target.value) < parseInt(e.target.getAttribute('min'))) {
            e.target.value = e.target.getAttribute('min');
        }
    }

    return (
        <div>
            <div id="menuContent">
            <div className="section" id="room">
            <h3>Ruimte</h3>
                <div className="row"><span className="label">Breedte</span><SimpleFormItem type="range" value={width} setValue={setWidth} min={250} max={750} step={1}/><SimpleFormItem type="select" value={width} setValue={setWidth}>
                    {
                        widthOptions.map((elm, i) => <option value={elm.value} key={i}>{elm.value}</option>)
                    }
                </SimpleFormItem><small>cm</small></div>
                <div className="row"><span className="label">Hoogte</span><SimpleFormItem type="range" value={height} setValue={setHeight} min={80} max={400} step={1}/><SimpleFormItem type="select" value={height} setValue={setHeight}>
                    {
                        heightOptions.map((elm, i) => <option value={elm.value} key={i}>{elm.value}</option>)
                    }
                </SimpleFormItem>
                <small>cm</small></div>
                <div className="row"><span className="label">Diepte</span><SimpleFormItem type="range" value={depth} setValue={setDepth} min={250} max={750} step={1}/><SimpleFormItem type="select" value={depth} setValue={setDepth}>
                    {
                       depthOptions.map((elm, i) => <option value={elm.value} key={i}>{elm.value}</option>)
                    }
                </SimpleFormItem>
                    <small>cm</small></div>
                <div className="row"><span className="label">Dakhoogte</span><SimpleFormItem type="range" value={roofHeight} setValue={setRoofHeight} min={0} max={500} step={1}/><SimpleFormItem type="select" value={roofHeight} setValue={setRoofHeight}>
                    {
                        roofHeightOptions.map((elm, i) => <option value={elm.value} key={i}>{elm.value}</option>)
                    }
                </SimpleFormItem>
                    <small>cm</small></div>


                <div className="row"><label>Ledverlichting: <input type="checkbox" checked={floorLedsOn} onChange={e => setFloorLedsOn(e.target.checked)}/></label></div>
                <div className="row floor">
                    <span className="label">Kleur vloer</span>
                    <label><span className="floor-light" data-color={floorColor}><span className="inner"></span></span><SimpleFormItem type="radio" name="floorcolor" value={FloorColors.Light} setValue={setFloorColor} onChange={e => setFloorColor(FloorColors.Light)} /></label>
                    <label><span className="floor-dark" data-color={floorColor}><span className="inner"></span></span><SimpleFormItem type="radio" name="floorcolor" value={FloorColors.Dark} setValue={setFloorColor} onChange={e => setFloorColor(FloorColors.Dark)} checked="checked"/></label>
                    <label><span className="floor-red" data-color={floorColor}><span className="inner"></span></span><SimpleFormItem type="radio" name="floorcolor" value={FloorColors.Red} setValue={setFloorColor} onChange={e => setFloorColor(FloorColors.Red)}/></label>
                    <label><span className="floor-blue" data-color={floorColor}><span className="inner"></span></span><SimpleFormItem type="radio" name="floorcolor" value={FloorColors.Blue} setValue={setFloorColor} onChange={e => setFloorColor(FloorColors.Blue)}/></label>
                </div>
                <button className="next" onClick={() => scrollParentToChild(document.getElementById('menu'), document.getElementById('video'))}>Naar scherm en projectie</button>
            </div>
            <div className="section" id="video">
                <h3>Scherm en projectie</h3>
                <div className="row"><span className="label">Breedte scherm</span><SimpleFormItem type="range" value={screenSize}
                                                                                         setValue={setScreenSize}
                                                                                         step={1}
                                                                                         min={screenRange[0]}
                                                                                         max={screenRange[1]}/> <SimpleFormItem type="number" value={screenSize}  min={screenRange[0]} max={screenRange[1]} step={1} setValue={setScreenSize} onInput={e => checkNumberField(e)}/><small>cm</small>
                </div>
                <div className="row"><label>Type projectie</label> <SimpleFormItem type="select" value={projectorType} setValue={setProjectorType}>
                    <option value="Front">Front projectie</option>
                    <option value="UST">Ultra Short Throw</option>
                </SimpleFormItem></div>

                {(() => {
                    if (projectorType === "Front") {
                        if (ScreenConfig.[screenID].type !== ScreenType.Projector) {
                            setScreenID(ScreenConfig.epson_qb_1000B.id);
                        }
                        return  <div className="row"><label>Projector</label> <SimpleFormItem type="select"
                                                                                              value={screenID}
                                                                                              setValue={setScreenID}>
                            <option value={ScreenConfig.epson_qb_1000B.id}>Epson QB 1000B</option>
                            <option value={ScreenConfig.epson_ls_12000w.id}>Epson LS11000W</option>
                            <option value={ScreenConfig.epson_ls_12000.id}>Epson LS12000B</option>
                            <option value={ScreenConfig.jvc_nz500.id}>JVC NZ500</option>
                            <option value={ScreenConfig.jvc_nz700.id}>JVC NZ700</option>
                            <option value={ScreenConfig.jvc_nz800.id}>JVC NZ800</option>
                            <option value={ScreenConfig.jvc_nz900.id}>JVC NZ900</option>
                            <option value={ScreenConfig.sony_vplxw5000es.id}>Sony VPLXW5000es</option>
                            <option value={ScreenConfig.sony_vplxw5000esw.id}>Sony VPLXW5000esw</option>
                            <option value={ScreenConfig.sony_vplxw6100es.id}>Sony VPLXW6100es - Bravia 8</option>
                            <option value={ScreenConfig.sony_vplxw6100esw.id}>Sony VPLXW6100esw - Bravia 8</option>
                            <option value={ScreenConfig.sony_vplxw8100es.id}>Sony VPLXW8100es - Bravia 9</option>
                            <option value={ScreenConfig.sony_vplxw8100esw.id}>Sony VPLXW8100esw - Bravia 9</option>
                        </SimpleFormItem></div>
                    } else {
                        if (ScreenConfig.[screenID].type !== ScreenType.UltraShortThrow) {
                            setScreenID(ScreenConfig.epson_ls800.id);
                        }
                        return  <div className="row"><label>Projector</label> <SimpleFormItem type="select"
                                                                                              value={screenID}
                                                                                              setValue={setScreenID}>
                            <option value={ScreenConfig.epson_ls800.id}>Epson LS 800</option>
                            <option value={ScreenConfig.awol_ltv3000pro.id}>Awol LVT-3000 PRO</option>
                            <option value={ScreenConfig.awol_ltv3500pro.id}>Awol LVT-3500 PRO</option>
                            <option value={ScreenConfig.samsung_lsp7t.id}>Samsung LSP7T</option>
                            <option value={ScreenConfig.samsung_lsp9t.id}>Samsung LSP9T</option>
                        </SimpleFormItem></div>
                    }
                })()}

                <div className={"row"}><a rel="noopener noreferrer" target="_blank" href={ScreenConfig.[screenID].url}>Bekijk deze projector in onze shop</a></div>

                <div className="row"><label>Aspect ratio</label> <SimpleFormItem type="select" value={aspectRatio}
                                                                                 setValue={v => setAspectRatio(v)}>
                    {
                        aspectRatios.map((elm, i) => <option value={elm} key={i}>{elm}</option>)
                    }
                </SimpleFormItem></div>
                <div className="row"><span className="label">Afstand tot scherm</span><SimpleFormItem type="range" value={Math.round(distance)} setValue={setDistance} min={1} max={freeDepth} step={1}/> <SimpleFormItem type="number" value={Math.round(distance)}  min={1} max={depth} step={1} setValue={setDistance} onInput={e => checkNumberField(e)}/><small>cm</small></div>
                <button className="next" onClick={() => scrollParentToChild(document.getElementById('menu'), document.getElementById('audio'))}>Naar audio setup</button>
            </div>
            <div className="section" id="audio">
            <h3>Audio setup</h3>
                <div className="row"><label>Type</label>
                    <SimpleFormItem type="select" value={audioConfigID} setValue={setAudioConfigID}>
                        <option value="klipsch">Klipsch Reference Premiere</option>
                        <option value="waterfall">Waterfall Audio Pro Custom</option>
                    </SimpleFormItem>
                </div>
                <div className={"row"}><a rel="noopener noreferrer" target="_blank" href={AudioConfig.[audioConfigID].url}>Bekijk in onze shop</a></div>
                <div className="row"><label>Surround Type</label>
                <SimpleFormItem type="select" value={surroundType} setValue={setSurroundType}>
                    <option value="5.1">5.1</option>
                    <option value="7.1">7.1</option>
                    <option value="5.1.2">5.1.2</option>
                    <option value="5.1.4">5.1.4</option>
                    {speakerType === SpeakerType.Waterfall && (<option value="5.2.4">5.2.4</option>)}
                    <option value="7.1.2">7.1.2</option>
                    <option value="7.1.4">7.1.4</option>
                    {speakerType === SpeakerType.Waterfall && (<option value="7.2.4">7.2.4</option>)}
                </SimpleFormItem>
                </div>
                <div className="row" data-disabled={!builtInWall}><label>Acoustisch transparant scherm
                    <input type="checkbox" checked={acousticTransparent}
                           onChange={e => setAcousticTransparent(e.target.checked)}
                           disabled={speakerType === SpeakerType.Waterfall || !builtInWall}/></label></div>
                <div className="row" data-disabled={!builtInWall}><label>Maak luidsprekers zichtbaar
                    <input type="checkbox" checked={transparentWalls}
                           onChange={e => setTransparentWalls(e.target.checked)}
                           disabled={!builtInWall}/></label></div>
                <div className="row" data-disabled={surroundType !== "7.1.2"}><label>Achterste luidsprekers in plafond
                <input type="checkbox" checked={rearInCeiling}
                                       onChange={e => setRearInCeiling(e.target.checked)}
                       disabled={numCeilingSpeakers !== 2}/></label></div>

                {(() => {
                    if (speakerType === SpeakerType.Waterfall) {
                        return <div className="speakers" data-speakers={"waterfall" + surroundType} />
                    }
                    else {
                        return <div className="speakers" data-speakers={surroundType} />
                    }
                })()}
                <button className="next" onClick={() => scrollParentToChild(document.getElementById('menu'), document.getElementById('seats'))}>Naar zitcomfort</button>
            </div>
            <div className="section" id="seats">
            <h3>Zitcomfort</h3>
                <div className="row"><label>Type</label> <SimpleFormItem type="select" value={seatType} setValue={setSeatType}>
                    <option value="chair">Bioscoopstoel</option>
                    <option value="seat">Bioscoopzetel</option>
                </SimpleFormItem></div>

                {(() => {
                    if (seatType === "chair") {
                        return  <div className="row"><label>Bioscoopstoel</label> <SimpleFormItem type="select" value={seatID} setValue={setSeatID}><option value="cinemove">Cine Move</option> <option value="cinehomedeluxe">Cine Home Deluxe</option> </SimpleFormItem></div>
                    }
                    else {
                        return  (
                            <div className="row"><label>Bioscoopzetel</label> <SimpleFormItem type="select" value={seatID} setValue={setSeatID}>
                                <option value="selena">Selena</option>
                                <option value="roma">Roma</option>
                                <option value="odeon">Odeon</option>
                            </SimpleFormItem></div>
                        );
                    }
                })()}
                <div className={"row"}><a rel="noopener noreferrer" target="_blank" href={SeatConfig.[seatID].url}>Bekijk in onze shop</a></div>

                <div className="row seatcolors"><span className="label">Kleur</span> {
                    models.map((elm, i) =>
                        <label key={i}><span className={"color color-" + elm.name}></span><SimpleFormItem type="radio" name="seatcolor" data-seat={seatID} value={i} key={i} setValue={setModelID} onClick={e => setModelID(i)} /></label>
                    )
                }</div>
                <div className="row"><span className="label">Aantal per rij</span><SimpleFormItem type="range" value={numSeats} setValue={setNumSeats} min={2} max={6} step={1}/> <SimpleFormItem type="number" value={numSeats}  min={2} max={6} step={1} setValue={setNumSeats} onInput={e => checkNumberField(e)}/></div>
                <div className="row"><span className="label">Aantal rijen</span><SimpleFormItem type="range" value={numRows} setValue={setNumRows} min={1} max={6} step={1}/> <SimpleFormItem type="number" value={numRows}  min={1} max={6} step={1} setValue={setNumRows} onInput={e => checkNumberField(e)}/></div>
                <div className="row-extended" data-rows={numRows}>
                    <div className="row"><span className="label">Primaire zitpositie</span><SimpleFormItem type="range" value={preferredRow} setValue={setPreferredRow} min={0} max={numRows-1} /><small>Rij {preferredRow+1} </small></div>
                <div className="row"><span className="label">Extra breedte podium</span><SimpleFormItem type="select" value={aisleMode} setValue={setAisleMode}>
                    <option value={AisleMode.Left}>Links</option>
                    <option value={AisleMode.Right}>Rechts</option>
                    <option value={AisleMode.Both}>Beide kanten</option>
                </SimpleFormItem></div>
                    <div className="row"><SimpleFormItem type="range" value={aisleWidth} setValue={setAisleWidth} min={0} max={maxAisleWidth} step={1}/><SimpleFormItem type="number" value={aisleWidth}  min={0} max={4} step={maxAisleWidth} setValue={setAisleWidth} onInput={e => checkNumberField(e)}/><small>cm</small></div>
                </div>
                <button className="next summary" onClick={() => document.getElementById('summaryForm').style.display = "block"}>Samenvatting</button>
            </div>
            </div>
        </div>
    );
}
